import RxProductActionContent from "./RxProductActionContent";

export default RxProductActionContent;
